<template>
  <div v-if="$store.getters.getSessions.length">
    <vue-headful :title="doctitle" />
    <div
      class="margin-images-container mx-auto position-relative"
      style="max-width: 1900px; overflow: visible"
    >
      <b-container
        style="max-width: 830px; min-height: 190px"
        class="page-top-margin"
      >
        <b-row>
          <b-col>
            <h1>My schedule</h1>
            <div v-if="!schedule.length">
              <h2>Oops!</h2>
              <p>
                Looks like you didn't add any sessions to your schedule yet, but
                don't worry,<br aria-hidden="true" />
                just go to <router-link to="/line-up">Line-up</router-link> and
                use the add button to get started!
              </p>
            </div>
            <div v-else>
              <p v-if="$route.params.id && !$route.query.nochange">
                All changes to your schedule are saved automatically, and you
                can always find its latest version at
                <a :href="'/my-schedule/' + $route.params.id"
                  >https://oredev.org/my-schedule/{{ $route.params.id }}</a
                >
                on any device. (You can find this link in your inbox.)
              </p>
              <p>
                We love it you are planning your Øredev experience with such
                care, that's precisely what we aspire at, too.
              </p>
              <a
                class="btn btn-lime-green"
                v-if="$route.params.id && $route.query.nochange"
                @click="schedule_revertSchedule"
                >Revert to my schedule
                <i class="pl-1 material-icons align-middle">upload</i></a
              >
              <a
                class="btn btn-lime-green"
                v-else-if="!$route.params.id"
                v-b-modal.saveschedule
                >Save my schedule
                <i class="pl-1 material-icons align-middle">download</i></a
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
      <!-- Title Gutter Images -->
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 9%; top: -30%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute gutter-image"
        style="width: 14%; left: 6%; top: 75%"
        alt=""
        aria-hidden="true"
      />
    </div>

    <b-container fluid class="mb-5 mt-5" v-if="schedule.length">
      <b-row>
        <b-col class="text-center">
          <button
            v-for="day in days"
            :key="day.value"
            @click="selectedDay = day.value"
            :class="{ active: selectedDay == day.value }"
            class="btn-mint"
          >
            {{ day.label }}
          </button>
        </b-col>
      </b-row>
    </b-container>

    <!-- My Sessions -->
    <div class="margin-images-container mx-auto" ref="marginImagesContainer">
      <b-container
        v-if="schedule.length"
        style="max-width: 830px; margin-bottom: 100px"
      >
        <b-row>
          <b-col class="text-center">
            <h2 v-if="mySessions.length">Your added sessions</h2>
            <p v-else>
              <b>
                Looks like you don't have any sessions scheduled on
                {{ selectedDayLabel }} yet.
              </b>
            </p>
          </b-col>
        </b-row>

        <b-container fluid>
          <b-row
            v-for="(session, index) in mySessions"
            :key="index"
            class="session"
          >
            <b-col cols="6" md="auto" class="order-1" style="min-width: 120px">
              <span class="session-time">
                {{ timeLabel(session.start) }}
              </span>
            </b-col>
            <b-col cols="12" md="8" class="session-content order-3 order-md-2">
              <b-row class="mb-2">
                <b-col>
                  <span>
                    {{ session.speakerName }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="session-info">
                    <SessionTag :tag="session.tag" />
                    <div class="time-tag">
                      <img
                        src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/clock.svg"
                      />
                      <span> Time: {{ session.duration }} min </span>
                    </div>
                    <RoomButton
                      :room="session.roomName"
                      @click="showMap(session.roomName)"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row
                v-b-toggle="'session-' + session._id"
                role="button"
                tabindex="0"
                class="pointer"
              >
                <b-col class="d-flex align-items-center">
                  <span class="session-title mr-2">{{ session.title }}</span>
                  <b-icon
                    :icon="isOpen[session._id] ? 'chevron-up' : 'chevron-down'"
                    class="ml-auto mr-2"
                  />
                </b-col>
              </b-row>
              <b-collapse
                :id="'session-' + session._id"
                @show="isOpen[session._id] = true"
                @hide="isOpen[session._id] = false"
                :visible="isOpen[session._id]"
              >
                <b-row class="mt-3">
                  <b-col>
                    <p>
                      {{ session.description }}
                    </p>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-col>
            <b-col cols="6" md="2" class="order-2 order-md-3">
              <button
                class="btn btn-lime-green remove-session-button float-right"
                @click="schedule_edit(session._id)"
              >
                Remove
              </button>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
      <!-- My Sessions Gutter Images -->
      <b-img
        ref="img1"
        v-show="visibleImages.img1"
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 9%; top: 615px"
        alt=""
        aria-hidden="true"
      />
      <b-img
        ref="img2"
        v-show="visibleImages.img2"
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute gutter-image"
        style="width: 10%; left: 8%; top: 890px"
        alt=""
        aria-hidden="true"
      />
    </div>
    <!-- Mobile Bottom images -->
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
      class="d-block d-sm-none mx-auto my-5"
      style="width: 36vw"
      alt=""
      aria-hidden="true"
    />
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_11.png"
      class="d-block d-sm-none mx-auto"
      style="width: 86vw"
      alt="A dancer in a costume of green netting"
    />
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_1.png"
        class="position-absolute"
        style="width: 25vw; left: 4vw; bottom: -5vw"
        alt="A group of delegates playing video games at Øredev."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_2.png"
        class="position-absolute"
        style="width: 25vw; left: 36vw; bottom: -6vw"
        alt="Silhouette of a delegate at the entrance to Øredev."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_3.png"
        class="position-absolute"
        style="width: 25vw; left: 62vw; bottom: -10.5vw"
        alt="Smiling delegates sitting on beach chairs at Øredev."
      />
    </b-container>
    <!-- Modals -->
    <MapModal ref="mapModal" />
    <EmailModal />
  </div>
</template>

<script>
import SessionTag from "@/components/SessionTag";
import RoomButton from "@/components/RoomButton";
import Toast from "@/components/Toast";
import MapModal from "@/components/modals/MapModal";
import EmailModal from "@/components/modals/EmailModal";
import schedule from "@/mixins/schedule";
import { mapMethods } from "@/mixins/helpers";

export default {
  name: "myschedule",
  components: {
    SessionTag,
    RoomButton,
    MapModal,
    EmailModal,
    Toast,
  },
  mixins: [schedule, mapMethods],
  data() {
    return {
      doctitle: "My Schedule - " + this.$store.state.conferencename,
      selectedDay: 3, // Default selected day
      days: [
        { label: "Wednesday", value: 3 },
        { label: "Thursday", value: 4 },
        { label: "Friday", value: 5 },
      ],
      // Expand session info
      isOpen: {},
      // Reactivity for margin images
      resizeObserver: null,
      visibleImages: {
        img1: true,
        img2: true,
      },
    };
  },
  mounted() {
    /* Reactivity for margin-images-container and images */
    // Initial check
    this.checkImageVisibility();

    // Observe container size changes
    this.resizeObserver = new ResizeObserver(() => {
      this.checkImageVisibility();
    });

    this.resizeObserver.observe(document.body);
  },
  beforeDestroy() {
    /* Reactivity for margin-images-container and images */
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  computed: {
    mySessions() {
      return this.$store.getters.getSessions.filter(
        (session) =>
          this.schedule.includes(session._id) &&
          session.weekDay == this.selectedDay
      );
    },
    selectedDayLabel() {
      const day = this.days.find((d) => d.value === this.selectedDay);
      return day ? day.label : "";
    },
  },
  watch: {
    // Make chevrons reactive
    mySessions: {
      immediate: true,
      handler(sessions) {
        sessions.forEach((session) => {
          this.$set(this.isOpen, session._id, false);
        });
      },
    },
  },
  methods: {
    timeLabel(time) {
      const [hourStr, minuteStr] = time.split(":");
      let hour = parseInt(hourStr, 10);
      const minute = minuteStr.padStart(2, "0");

      const ampm = hour >= 12 ? "pm" : "am";
      hour = hour % 12 || 12; // convert 0 to 12 and 13+ to 1-11

      return `${hour}:${minute} ${ampm}`;
    },
    checkImageVisibility() {
      // Checks if entire image fits in the container
      const container = this.$refs.marginImagesContainer;
      if (!container) return;
      const containerHeight = container.getBoundingClientRect().height;

      // image height and top position
      if (containerHeight > 200 + 890) {
        // Show both images
        this.$set(this.visibleImages, "img1", true);
        this.$set(this.visibleImages, "img2", true);
      } else if (containerHeight > 180 + 615) {
        // Show first image
        this.$set(this.visibleImages, "img1", true);
        this.$set(this.visibleImages, "img2", false);
      } else {
        // Show no image
        this.$set(this.visibleImages, "img1", false);
        this.$set(this.visibleImages, "img2", false);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.page-top-margin {
  margin-top: 48px;

  @media (min-width: 768px) {
    margin-top: 130px;
  }
}

h1 {
  font-weight: 400;
  font-size: 18px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
}

h2 {
  font-family: Lexend, sans-serif;
  font-weight: 500;
  font-size: 20px;
  font-size: 18px;
  line-height: 31px;
  letter-spacing: 0;
  text-transform: none;

  @media (min-width: 18px) {
    font-size: 20px;
  }
}

span {
  font-family: Lexend, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.05rem;
}

.session {
  display: flex !important;
  border-radius: 5px;
  box-shadow: 0px 2px 9px 0px #0000002b;
  margin-bottom: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  .session-time {
    font-family: Lexend, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 144%;
    letter-spacing: 0.05rem;
  }
  .session-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap; /* Allows wrapping if needed on small screens */
    gap: 8px; /* Adds spacing between spans */
    margin-bottom: 8px;
    .time-tag {
      background-color: $light-grey;
      display: flex; /* Horizontal layout */
      align-items: center; /* Vertically center image + text */
      align-self: start;
      width: fit-content;
      border-radius: 5px;
      padding: 4px 8px;
      gap: 4px;

      img {
        width: 16px;
      }
      span {
        font-weight: 300;
      }
    }
  }
  .session-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 144%;
  }
  .remove-session-button {
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0.05rem;
  }
}

.margin-images-container {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  max-width: 1900px;
}

.gutter-image {
  @media (max-width: 1399px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MySchedule.vue